import { Core } from "@faire/design-tokens";
import { NameAndMore } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/__internal__/NameAndMore";
import { Column } from "@faire/web/slate/Layout";
import styled, { css } from "styled-components";

const LeanBrandTileWrapper = styled(Column)<{
  $border?: boolean;
}>`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: ${Core.surface.inverse};
  ${(props) =>
    props.$border
      ? css`
          border: 1px solid ${Core.border.muted};
        `
      : ""};
`;

const StyledNameAndMore = styled(NameAndMore)``;

export namespace LeanBrandTileStyles {
  export const Wrapper = LeanBrandTileWrapper;
  export const NameAndMore = StyledNameAndMore;
}
